import React from 'react'

const SeoCourse = ({ register }) => {

  return (
    <>
        <div class="row mb-3">
            <div class="col-md-3 mb-3">
                <label class="form-label">Meta Title</label>
                <input type="text" name="metaTitle" class="form-control" placeholder='Meta Title' {...register("metaTitle")} />
            </div>
            <div class="col-md-3 mb-3">
                <label class="form-label">Meta Keywords</label>
                <input type="text" name="metaKeywords" class="form-control" placeholder='Meta Keywords' {...register("metaKeywords")} />
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Meta Description</label>
                <textarea type="text" name="metaDescription" class="form-control" placeholder='Meta Description' {...register("metaDescription")}></textarea>
            </div>
            <div class="col-md-3 mb-3">
                <label class="form-label">URL Slug </label>
                <input type="text" name="slug" class="form-control" placeholder='Slug Name' {...register("slug")} />
            </div>
        </div>
    </>
  )
}

export default SeoCourse
